export default __webpack_public_path__ + "static/media/SoundBoothIcon.a695a99e.svg";